import { createI18n } from 'vue-i18n';
import messages from './index';

// 获取浏览器语言
const getBrowserLanguage = () => {
  const language = navigator.language.toLowerCase();
  const locales = Object.keys(messages);
  
  // 检查完整匹配
  if (locales.includes(language)) {
    return language;
  }
  
  // 检查语言代码匹配（例如 'zh' 匹配 'zh-cn'）
  const languageCode = language.split('-')[0];
  const matchingLocale = locales.find(locale => locale.startsWith(languageCode));
  
  return matchingLocale || 'zh-cn'; // 默认使用中文
};

// 创建 i18n 实例
const i18n = createI18n({
  locale: getBrowserLanguage(), // 使用浏览器语言
  fallbackLocale: 'zh-cn',     // 默认语言
  messages,                     // 语言包
  legacy: false,               // 使用组合式API
  globalInjection: true,       // 全局注入 $t 方法
});

export default i18n;

// 导出一些常用的工具函数
export const setLanguage = (locale) => {
  i18n.global.locale.value = locale;
  // 可以在这里添加持久化存储语言选择
  localStorage.setItem('language', locale);
};

export const getLanguage = () => {
  return i18n.global.locale.value;
};

export const t = (key) => {
  return i18n.global.t(key);
}; 